<template>
  <b-modal ref="poModal"
           size="xl"
           :hide-footer="true"
           scrollable
           @hide="$emit('hide')"
  >
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.PO.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div class="d-flex flex-column w-100 h-100">
      <div class="d-flex justify-content-end w-100" style="height: 35px;">
        <i class="fas fa-file-excel text-third" style="font-size: 24px;" @click="exportExcel" v-b-tooltip.hover.topleft :title="'Exportar Excel'"></i>
      </div>
      <ag-grid-vue id="obras-grid"
                   class="ag-theme-alpine d-flex flex-grow-1 w-100 h-100"
                   rowSelection="single"
                   :enableRangeSelection="true"
                   :getLocaleText="localeTextFunc"
                   :gridOptions="poGridOptions"
                   :columnTypes="columnTypes"
                   :columnDefs="poColumnDefs"
                   :defaultColDef="defaultColumnDef"
                   :rowData="list"
                   :getRowId="params => params.data.id"
                   suppressContextMenu
                   suppressHorizontalScroll
                   :excelStyles="poExcelStyles"
                   stopEditingWhenCellsLoseFocus
                   :suppressColumnVirtualisation=true
                   :masterDetail=true
                   :detailCellRendererParams="detailCellRendererParams"
                   @grid-ready="onGridReady"
                   >
      </ag-grid-vue>
      <div class="row justify-content-center">
        <div style="width: 25rem;">
          <div class="row justify-content-end align-items-center">
            <strong>Total PO</strong>
            <div class="form-control text-right mx-3" style="width: 15rem;">{{ total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</div>
          </div>
          <div class="row justify-content-end align-items-center">
            <strong>Total Recebido</strong>
            <div class="form-control text-right m-3" style="width: 15rem;">{{ totalPago.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PurchaseOrderRepository from '@/shared/http/repositories/business/purchaseorder'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../../mixins/gridMixin'

export default {
  name: 'PurchaseOrderClient',
  mixins: [CompanyMixin, gridMixin],
  components: {
    AgGridVue
  },
  data () {
    return {
      list: [],
      poExcelStyles: [],
      poGridOptions: {
        groupHeaderHeight: 15,
        headerHeight: 40,
        rowHeight: 30,
        detailRowAutoHeight: true
      },
      poColumnDefs: [
        {
          headerName: 'Pedido',
          field: 'po',
          flex: 55
        },
        {
          headerName: 'Data Lançamento',
          field: 'dtLancto',
          type: 'dateColumn',
          flex: 50
        },
        {
          headerName: 'Total PO',
          field: 'totalPO',
          type: 'numberColumn',
          flex: 50
        },
        {
          headerName: 'Total Recebido',
          field: 'total',
          type: 'numberColumn',
          flex: 50,
          cellRenderer: 'agGroupCellRenderer',
          valueFormatter: params =>
            params.value != null
              ? params.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '',
          headerComponentParams: {
            template:
              `<div style="cursor:pointer; display: flex; align-items: center; gap: 4px;">
                <i id="iconExpand" class="fas fa-solid fa-chevron-right mx-2"></i>
                <span>Total Recebido</span>
              </div>`
          }
        }
      ],
      detailCellRendererParams: {}
    }
  },
  computed: {
    total () {
      let total = 0
      if (this.list) {
        total = this.list.reduce((tot, curr) => (
          tot += curr.totalPO
        ), 0)
      }
      return total
    },
    totalPago () {
      let total = 0.00
      if (this.list) {
        total = this.list.reduce((tot, curr) => (
          tot += curr.total
        ), 0.00)
      }
      return total
    }
  },
  methods: {
    show (obraId) {
      this.poExcelStyles = [...this.excelStyles,
        {
          id: 'title',
          alignment: {
            vertical: 'Center'
          },
          interior: {
            color: '#046437',
            pattern: 'solid'
          },
          font: {
            bold: true,
            color: '#FFFFFF',
            size: 18
          }
        },
        {
          id: 'footer',
          font: {
            bold: true
          }
        }
      ]
      loading.push()
      PurchaseOrderRepository.GetByWork({params: {obraId: obraId}})
        .then(response => {
          if (response.data.code > 0) {
            this.list = response.data.data
            this.$refs.poModal.show()
          } else throw new Error(response.data.message)
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    exportExcel () {
      const paidValue = this.totalPago
      const totalValue = this.total
      const append = () => ({
        autoConvertFormulas: true,
        processCellCallback (params) {
          if (params.value === '#NA#') {
            return '=NA()'
          }
          return params.value
        },
        prependContent: [
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]},
          {cells: [
            {data: {value: 'PO', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]},
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]}
        ],
        appendContent: [
          {cells: []},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Total PO', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: paidValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Total Pago', type: 'String'}, styleId: ['ag-right-aligned-cell', '  ']},
            {data: {value: totalValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]}
        ],
        getCustomContentBelowRow (params) {
          const masterRow = params.node.data
          if (!masterRow || !masterRow.detalhe || masterRow.detalhe.length === 0) {
            return []
          }

          const headerRow = {
            cells: [
              { data: { value: 'Item', type: 'String' }, styleId: 'header' },
              { data: { value: 'Etapa', type: 'String' }, styleId: 'header' },
              { data: { value: 'Candidato', type: 'String' }, styleId: 'header' },
              { data: { value: 'Nota Fiscal Nº', type: 'String' }, styleId: 'header' },
              { data: { value: 'Data Recebimento', type: 'String' }, styleId: 'header' },
              { data: { value: 'Valor PO', type: 'String' }, styleId: 'header' },
              { data: { value: 'Valor Recebido', type: 'String' }, styleId: 'header' }
            ]
          }

          const detailRows = masterRow.detalhe.map(item => ({
            cells: [
              { data: { value: item.item || '', type: 'String' } },
              { data: { value: item.etapa || '', type: 'String' } },
              { data: { value: item.candidato || '', type: 'String' } },
              { data: { value: item.nf || '', type: 'String' } },
              {
                data: {
                  value: item.dtReceb
                    ? new Date(item.dtReceb).toLocaleDateString('pt-BR')
                    : '',
                  type: 'String'
                }
              },
              { data: { value: item.valorPO ? item.valorPO : 0.00, type: 'Number' }, styleId: 'floatType' },
              { data: { value: item.valor ? item.valor : 0.00, type: 'Number' }, styleId: 'floatType' }
            ]
          }))

          return [headerRow, ...detailRows, { cells: [] }]
        },
        columnWidth: 150
      })
      this.poGridOptions.api.exportDataAsExcel(append())
    },
    onClose () {
      this.$refs['poModal'].hide()
      this.$emit('hide')
    },
    onGridReady (params) {
      this.gridApi = params.api

      params.api.addEventListener('rowGroupOpened', this.updateHeaderIcon)
      // também rodar uma vez no início
      this.updateHeaderIcon()

      this.gridColumnApi = params.columnApi
      const gridEl = document.getElementById('obras-grid')
      const headerRoot = gridEl ? gridEl.querySelector('.ag-header') : document.querySelector('.ag-header')
      if (!headerRoot) {
        console.warn('Não encontrei .ag-header')
        return
      }
      if (this._headerClickHandler) headerRoot.removeEventListener('click', this._headerClickHandler)
      this._headerClickHandler = (e) => {
        const headerCell = e.target.closest('.ag-header-cell')
        if (!headerCell) return
        const colId = headerCell.getAttribute('col-id')
        if (!colId) return
        if (colId === 'total') {
          setTimeout(() => {
            let anyExpanded = false
            params.api.forEachNode(node => {
              if (node.master && node.expanded) {
                anyExpanded = true
              }
            })

            params.api.forEachNode(node => {
              if (node.master) {
                node.setExpanded(!anyExpanded)
              }
            })

            this.updateHeaderIcon() // mantém ícone sincronizado
          }, 0)
        }
      }

      headerRoot.addEventListener('click', this._headerClickHandler)
    },
    // beforeDestroy () {
    //   const gridEl = document.getElementById('obras-grid')
    //   const headerRoot = gridEl && gridEl.querySelector('.ag-header')
    //   if (headerRoot && this._headerClickHandler) headerRoot.removeEventListener('click', this._headerClickHandler)
    // },
    beforeDestroy () {
      const gridEl = document.getElementById('obras-grid')
      const headerRoot = gridEl && gridEl.querySelector('.ag-header')
      if (headerRoot && this._headerClickHandler) {
        headerRoot.removeEventListener('click', this._headerClickHandler)
      }
      if (this.gridApi) {
        this.gridApi.removeEventListener('rowGroupOpened', this.updateHeaderIcon)
      }
    },
    updateHeaderIcon () {
      if (!this.gridApi) return

      let expanded = 0
      let total = 0
      this.gridApi.forEachNode(node => {
        if (node.master) {
          total++
          if (node.expanded) expanded++
        }
      })
      const icon = document.querySelector('#iconExpand')
      if (!icon) return

      if (expanded === 0) {
        icon.className = 'fas fa-solid fa-chevron-right mx-2'
      } else if (expanded === total) {
        icon.className = 'fas fa-solid fa-chevron-down mx-2'
      } else {
        // estado misto → escolhe um ícone (ou um "fa-minus")
        icon.className = 'fas fa-solid fa-minus mx-2'
      }
    }
  },
  mounted () {
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnTypes: this.columnTypes,
        getLocaleText: this.localeTextFunc,
        columnDefs: [
          { field: 'item', headerName: 'Item' },
          { field: 'etapa', headerName: 'Etapa', width: 375 },
          {
            headerName: 'Candidato',
            valueGetter: (param) => param.data.candidato || '#NA#',
            type: 'textColumn'
          },
          { field: 'nf', headerName: 'Nota Fiscal Nº' },
          {
            field: 'dtReceb',
            headerName: 'Data Recebimento',
            valueFormatter: params => {
              if (!params.value) return ''
              const date = new Date(params.value)
              return date.toLocaleDateString('pt-BR')
            },
            minWidth: 150
          },
          {
            field: 'valorPO',
            headerName: 'Valor PO',
            valueFormatter: params =>
              params.value != null
                ? params.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '',
            minWidth: 150,
            width: 150,
            type: 'numberColumn'
          },
          {
            field: 'valor',
            headerName: 'Valor Recebido',
            valueFormatter: params =>
              params.value != null
                ? params.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '',
            minWidth: 150,
            width: 150,
            type: 'numberColumn'
          }
        ]
      },
      getDetailRowData: params => {
        params.successCallback(params.data.detalhe)
      }
    }
  }
}
</script>

<style scoped>
.ag-theme-alpine {
  --ag-header-background-color: #008143;
}
* >>> .ag-root-wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/po/po.vue